import { AxiosStatic, AxiosResponse } from 'axios';
import { Holiday } from './Holiday';
import VersionedResource from '../VersionedResource';

export default class HolidayResource extends VersionedResource {
  public async getAll(fiId: number) : Promise<Holiday[]> {
    const url = `/api/rcx/config/${fiId}/holiday`;
    const response: AxiosResponse = await this.apiClient.get(url);
    return response.data.data;
  }

  public async save(fiId: string, data: Holiday): Promise<Holiday> {
    const url = `/api/rcx/config/${fiId}/holiday`;
    let response: AxiosResponse;

    const toSave: any = {};
    Object.assign(toSave, data);

    if (data.id) {
      response = await this.apiClient.put(`${url}/${data.id}`, toSave);
    } else {
      response = await this.apiClient.post(url, toSave);
    }

    const savedRule: Holiday = response.data.data;
    return savedRule;
  }

  public async remove(fiId: number, holidayId: number): Promise<AxiosResponse> {
    return this.apiClient.delete(`/api/rcx/config/${fiId}/holiday/${holidayId}`);
  }
}
